import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import Keycloak from 'keycloak-js';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { UserInformation } from './model/keycloak/user-information.model';
import { PackageService } from './services/package.service';
import { MatDivider } from '@angular/material/divider';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MatToolbar,
    MatIcon,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    RouterLink,
    MatDivider,
    RouterLinkActive,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly keycloak: Keycloak = inject(Keycloak);
  public readonly packageService = inject(PackageService);
  public userInformation: UserInformation = new UserInformation();

  constructor() {
    this.loadUserInformation();
  }

  private loadUserInformation() {
    this.keycloak.loadUserInfo().then(userInfo => {
      this.userInformation = UserInformation.createFromApi(userInfo);
    });
  }

  public logOut(): void {
    this.keycloak.logout();
  }
}
